import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import styles from './LinkSection.module.scss';

type LinkSectionProps = {
  heading: string;
  links: { url: string; title: string }[];
};

const LinkSection = ({ heading, links }: LinkSectionProps) => (
  <div className={styles.container}>
    <Typography variant="heading200" component="div" className={styles.header}>
      {heading}
    </Typography>
    <div className={styles.columnedSection}>
      <ul className={styles.linksColumn}>
        {links.slice(0, 8).map(link => (
          <li key={link.url} className={styles.listItem}>
            <Link href={link.url} size='sm' variant='secondary' noUnderline>
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
      <ul className={styles.linksColumn}>
        {links.slice(8, 15).map(link => (
          <li key={link.url} className={styles.listItem}>
            <Link href={link.url} size='sm' variant='secondary' noUnderline>
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default LinkSection;
